var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4663_7184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2632 1.5H4.89474C3.85263 1.5 3 2.35909 3 3.40909V16.7727H4.89474V3.40909H16.2632V1.5ZM19.1053 5.31818H8.68421C7.64211 5.31818 6.78947 6.17727 6.78947 7.22727V20.5909C6.78947 21.6409 7.64211 22.5 8.68421 22.5H19.1053C20.1474 22.5 21 21.6409 21 20.5909V7.22727C21 6.17727 20.1474 5.31818 19.1053 5.31818ZM19.1053 20.5909H8.68421V7.22727H19.1053V20.5909Z",
    fill: "#8890A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4663_7184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.620c24a5f6adda63786f499f2d31bbf0.svg";
export { ForwardRef as ReactComponent };